import Typography from '@components/basics/typography';
import * as React from 'react';

import { Translate } from 'react-localize-redux';

import NotificationRowCtrl from '../notification-row';

import TextWrapper from '../text-wrapper';

interface NotificationIntroductionProps {
  className?: string;
  username: string;
  isRead: boolean;
  timestamp: string;
  id: string;
  clearNotification: (id) => void;
}

export const NotificationIntroduction: React.FC<
  NotificationIntroductionProps
> = ({ className, username, isRead, timestamp, id, clearNotification }) => {
  return (
    <NotificationRowCtrl
      className={className}
      isRead={isRead}
      timestamp={timestamp}
      id={id}
      clearNotification={(id) => {
        clearNotification(id);
      }}
    >
      <TextWrapper
        justifyContent="flex-start"
        alignItems="baseline"
        isRead={isRead}
      >
        <Typography>
          <Translate id="NOTIFICATION.INTRODUCTION.TEXT.1" />
          &nbsp;
        </Typography>
        <Typography weight="700">{username}!!&nbsp;</Typography>
        <Typography>
          <Translate id="NOTIFICATION.INTRODUCTION.TEXT.2" />
          &nbsp;
        </Typography>
        <Typography>
          <i>
            <Translate id="NOTIFICATION.INTRODUCTION.TEXT.3" />
            &nbsp;
          </i>
        </Typography>
      </TextWrapper>
    </NotificationRowCtrl>
  );
};

export default NotificationIntroduction;
